import axios from 'axios';
export default class FreeService {
    async getFreeList(data) {
        return await axios.post('api/v1/admin/job-post/list', data);
    }
    // async addNotice(title, description, create_date) {
    //     return await axios
    //         .post(`api/v1/admin/notice/add`, {
    //             title: title,
    //             description: description,
    //             create_date: create_dateā,
    //         })
    //         .then((res) => res);
    // }
    async FreeDetail(ad_type_cat) {
        return await axios
        .post(`api/v1/admin/ad-type/info/details`, {
            ad_type_cat: ad_type_cat,
            })
            .then((res) => res.data.result);
    }
    async editPremium(data) {
        return await axios
        .post(`api/v1/admin/ad-type/edit`, data)
            .then((res) => res);
    }
    async FreeView(job_id) {
        return await axios
            .post(`api/v1/admin/job-post/view`, {
                job_id: job_id,
            })  
            .then((res) => res.data.result);
            
    }
    async UpdatePremium(data) {
        return await axios
            .post(`api/v1/admin/ad-type/info/edit`, data)
            .then((res) => res);
    }
    async ApproveFree(data) {
        return await axios
            .post(`api/v1/admin/job-post/change-status`, data)
            .then((res) => res);
    }
    async Rejected(data) {
        return await axios
            .post(`api/v1/admin/job-post/change-status`, data)
            .then((res) => res);
    }
}